import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const UpsellLeadList = Loadable(
  lazy(() =>
    import("./UpsellLead/UpsellLeadList").then(({ UpsellLeadList }) => ({
      default: UpsellLeadList,
    }))
  )
);

const Upsell = Loadable(
  lazy(() =>
    import("./Upsell").then(({ Upsell }) => ({
      default: Upsell,
    }))
  )
);

const UpsellDashboard = Loadable(
  lazy(() =>
    import("./UpsellDashboard").then(({ UpsellDashboard }) => ({
      default: UpsellDashboard,
    }))
  )
);

export const upsellRoutes = [
  {
    path: "/upsell-leads",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.UPSELL_INSIGNTS]}>
        <UpsellLeadList />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/upsell",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.UPSELL_INSIGNTS]}>
        <Upsell />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/upsell-dashboard",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.UPSELLING_DASHBOARD]}>
        <UpsellDashboard />
      </AuthorizedRoute>
    ),
  },
];
